module.exports = __webpack_public_path__ + "static/media/ic-streaming-mic-white.f876378c.svg";